import search from './search';
import navigation from './navigation';

export default {
    search,
    navigation
};
